<template>

        <auditoria_list cliente_oculto="1"></auditoria_list>
</template>
<script>

import AuditoriaList from '../auditoria/List';

export default {
  components: {
    auditoria_list: AuditoriaList
  }, 
  

}

</script>